export const SystemKeys = {
  IS_NOT_ENOUGH_CREDITS: 'IS_NOT_ENOUGH_CREDITS',
  IS_NOT_HAVE_BILLING_INFO: 'IS_NOT_HAVE_BILLING_INFO',
};

export const DomainCachedKey = {
  MAPPING_THRESHOLDS: 'mappingThresholds',
  REFETCH_DOMAIN_GROUP_LIST: 'REFETCH_DOMAIN_GROUP_LIST',
};

export const ContactCachedKey = {
  IS_HIDE_STATISTIC: 'IS_HIDE_STATISTIC',
  IS_BLACKLIST: 'IS_BLACKLIST',
  IS_MY_DATA: 'IS_MY_DATA',
  IS_TRIGGER_DATA: 'IS_TRIGGER_DATA',
  IS_SUPPRESSION: 'IS_SUPPRESSION',
  IS_FAILED: 'IS_FAILED',
  IS_DELIVERED: 'IS_DELIVERED',

  TYPE_CONTACT: 'TYPE_CONTACT',
  REFETCH_CONTACT_GROUP_LIST: 'REFETCH_CONTACT_GROUP_LIST',
  CONTACT_GROUP_SELECTED: 'CONTACT_GROUP_SELECTED',
  CONTACT_GROUP_LIST: 'CONTACT_GROUP_LIST',
  CHANGE_TAB_CONTACT_GROUP_LIST: 'CHANGE_TAB_CONTACT_GROUP_LIST',
  SET_CONTACT_GROUP_LIST: 'SET_CONTACT_GROUP_LIST',
  SET_CONTACT_GROUP_SELECTED: 'SET_CONTACT_GROUP_SELECTED',

  HEADERS_FOR_IMPORT: 'HEADERS_FOR_IMPORT',
};

export const HistoryCachedKey = {
  EACH_HISTORY_CAMPAIGN: (cpId) => `EACH_HISTORY_CAMPAIGN_${cpId}`,
  SUPPRESS_CONTACTS: (key) => `SUPPRESS_CONTACTS_${key}`,
  HAS_FAILED: (cpId) => `HAS_FAILED_${cpId}`,
};

export const CreativeCachedKey = {
  REFETCH_HISTORY_ASSISTANT: 'REFETCH_HISTORY_ASSISTANT',
  REGENERATE_CREATIVE_INFO: 'REGENERATE_CREATIVE_INFO',
};

export const DIDCachedKey = {
  REFETCH_LIST_DID: 'REFETCH_LIST_DID',
  ID_DID_GROUP: 'ID_DID_GROUP',
  DID_VOICE_ENABLED: 'DID_VOICE_ENABLED',
  DID_BUY_ABLE: 'DID_BUY_ABLE',

  DID_DETAIL: 'DID_DETAIL',
};

export const ResponderCachedKey = {
  REFETCH_LIST_RESPONDER: 'REFETCH_LIST_RESPONDER',
  IS_NODE_DELETED: 'IS_NODE_DELETED',
};

export const OfferCachedKey = {
  REFTECH_LIST_OFFER: 'REFTECH_LIST_OFFER',
};

export const MediaCachedKey = {
  REFETCH_LIST_MEDIA: 'REFETCH_LIST_MEDIA',
  REFETCH_LIST_AUDIO_HISTORY: 'REFETCH_LIST_AUDIO_HISTORY',
  REFETCH_LIST_MEDIA_GROUP: 'REFETCH_LIST_MEDIA_GROUP',
};

export const CampaignComposeKey = {
  REFETCH_SEARCH_CONTACT_GROUPS: 'REFETCH_SEARCH_DEVICE_GROUPS',
  CONTACT_GROUPS: 'CONTACT_GROUPS',
  REFETCH_ANIS_EACH_ROW_MONITORING_BY_CPID: (cpId) =>
    `REFETCH_ANIS_EACH_ROW_MONITORING_BY_CPID_${cpId}`,
  REFETCH_ANIS_DETAI_HISTORY_BY_CPID: (cpId) => `REFETCH_ANIS_DETAI_HISTORY_BY_CPID${cpId}`,
};

export const InboxCachedKey = {
  REFETCH_LIST_INBOX: 'REFETCH_LIST_INBOX',
  REFETCH_VIEW_THREAD: 'REFETCH_VIEW_THREAD',
};

export const CommonCachedKey = {
  NOTICE_NEW_CAMPAIGN: 'NOTICE_NEW_CAMPAIGN',
  NOTICE_NEW_FEATURE_CREATIVES: 'NOTE_NEW_FEATURE_CREATIVES',
};

export const ResponderV2Key = {
  REFETCH_RESPONDER_DETAIL: 'REFETCH_RESPONDER_DETAIL',
  NODE_SELECTING: 'NODE_SELECTING',
  CONTENT_NODES_SELECTING: 'NODES_SELECTING',
  EDGES_SELECTING: 'EDGES_SELECTING',
  TOOGLE_DETAIL_DIALOG: 'TOOGLE_DETAIL_DIALOG',
  RESPONDER_VIEW_ONLY: 'RESPONDER_VIEW_ONLY',
  RESPONDER_DETAIL: 'RESPONDER_DETAIL',

  RESPONDER_SIMULATOR_HANDLER: 'RESPONDER_SIMULATOR_HANDLER',
  RESPONDER_SIMULATING: 'RESPONDER_SIMULATING',
};

export const MonitoringKey = {
  MONITORING_MAIN: 'MONITORING_MAIN',
  MONITORING_FILTERS: 'MONITORING_FILTERS',
};

export const UserKeys = {
  REFETCH_ALT_SERVER_SIP_LIST: 'REFETCH_ALT_SERVER_SIP_LIST',
  PRICE_TABLE: 'PRICE_TABLE',
  COST_DATA_CONTACT_STORAGE: 'COST_DATA_CONTACT_STORAGE',
};
